// extracted by mini-css-extract-plugin
export default {"venueInfoForPrint":"style--venueInfoForPrint--164783"};